export class Images {
  main: string = '';
  list: string = '';
  logo: string = '';
  logoDark: string = '';
  header: string = '';
  specs: string = '';   
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/images.model.ts